import { logError } from "@/shared/logging/errors";

import { TastierClient } from "@/app/TastierClient";
import { getMessaging, getToken } from "firebase/messaging";

export class FirebaseHelper {
    public static getToken(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker
                    .register("./assets/js/firebase-messaging-sw.js")
                    .then(function (registration) {
                        const messaging = getMessaging(TastierClient.firebaseApp);
                        try {
                            getToken(messaging, {
                                    vapidKey: "BFuXVAD26Uqj-1JVzD0jedi3v-3woQIqJLLz_TVEJqaKJzWucZqo7gLOyy5sPynN230ZQ_9tXuZHqa9uU2B51B0",
                                    serviceWorkerRegistration: registration,
                                })
                                .then((currentToken) => {
                                    if (currentToken) {
                                        console.log("A new FCM token has been generated");
                                        resolve(currentToken);
                                    } else {
                                        reject(
                                            new Error(
                                                "No registration token available. Request permission to generate one."
                                            )
                                        );
                                    }
                                })
                                .catch((ex) => {
                                    logError(ex);
                                    reject(new Error(ex.message));
                                });
                        } catch (ex) {
                            logError(ex);
                            console.log((ex as any).message);
                            reject(new Error((ex as any).message));
                        }
                    })
                    .catch((ex) => {
                        logError(ex);
                        reject(new Error(ex.message));
                    });
            } else {
                console.log("Service worker is not available");
                reject(new Error("Service worker is not available"));
            }
        });
    }
}
